module.exports = __webpack_public_path__ + "static/media/spinner.8f0ccec5.gif";